import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items = [] }) {
  if (!items || items.length === 0) return null;

  const breadcrumbListSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://xn--hrvejenstrpleje-xlbj.dk${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="Brødkrummer" className="py-3 px-4 sm:px-6 max-w-7xl mx-auto w-full">
      <script type="application/ld+json">{JSON.stringify(breadcrumbListSchema)}</script>
      <ol className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm text-[#4a584e]">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-[#1c2620] hover:text-[#1b4332] font-medium transition-colors"
          >
            <i className="fa-solid fa-house text-xs text-[#2d6a4f]" aria-hidden="true" />
            <span>Forside</span>
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`crumb-${index}`} className="flex items-center gap-1.5">
              <span aria-hidden="true" className="text-[#8c9a90] text-xs">
                <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
              {isLast || !item.href ? (
                <span className="font-semibold text-[#1b4332]" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="hover:text-[#1b4332] hover:underline underline-offset-2 transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
